import React, { createContext, useState } from 'react';
import { useLazyQuery, useMutation } from 'react-apollo';

// MUTATIONS

// QUERIES
import EVENTS_TARGETS from '../../GraphQl/Queries/EVENTS_TARGETS';
import GET_CARTS from '../../GraphQl/Queries/GET_CARTS';
import GET_BASIC_TAG_ACTIVITY from '../../GraphQl/Queries/GET_BASIC_TAG_ACTIVITY';
import CREATE_TEST_SIGNAL_LOGS from '../../GraphQl/Mutations/CREATE_TEST_SIGNAL_LOGS';
import moment from 'moment';

const TagContext = createContext({});

export const TagProvider = (props) => {
  const { children } = props;

  const [fetchTags, { data: dataTags, loading: loadingTags }] = useLazyQuery(EVENTS_TARGETS, {
    fetchPolicy: 'no-cache',
  });

  const [fetchCarts, { data: carts, loading: cartsLoading }] = useLazyQuery(GET_CARTS, {
    fetchPolicy: 'no-cache',
  });

  const [basicTagActivityState, setBasicTagActivityState] = useState(null);

  const [getBasicTagActivity, { loading: tagActivityLoading, error: tagActivityError }] =
    useLazyQuery(GET_BASIC_TAG_ACTIVITY, {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        const { getBasicTagActivity } = data;
        // Store in local state for consumers and to allow manual clearing
        setBasicTagActivityState(getBasicTagActivity);
        createLogs({
          variables: {
            id: getBasicTagActivity.tagId,
            createLogs: [
              {
                testDate: moment().format(),
                pageViews: getBasicTagActivity.pageViews,
                signups: getBasicTagActivity.signups,
                transactions: getBasicTagActivity.transactions,
                total: getBasicTagActivity.total,
                sessions: getBasicTagActivity.sessions,
                impressions: getBasicTagActivity.impressions,
              }
            ],
            retailIds: getBasicTagActivity?.retailIds?.map((item) => ({
              retailId: item.retailID,
              pageViews: item.pageviews || 0,
              signups: item.signups || 0,
              transactions: item.transactions || 0,
              total: item.total || 0,
              sessions: item.sessions || 0,
              impressions: item.impressions || 0,
            })) ?? []
          }
        });
      },
    });

  const [createLogs] = useMutation(CREATE_TEST_SIGNAL_LOGS);

  return (
    <TagContext.Provider
      value={{
        fetchTags,
        tags: dataTags ? dataTags.eventsTargets : [],
        loadingTags,
        fetchCarts,
        carts: carts && carts.getCarts ? carts.getCarts : [],
        cartsLoading,
        getBasicTagActivity,
        tagActivityLoading,
        tagActivityError,
        createLogs,
        basicTagActivity: basicTagActivityState,
        clearBasicTagActivity: () => setBasicTagActivityState(null),
      }}
      {...props}
    >
      {children}
    </TagContext.Provider>
  );
};

export default TagContext;
